<template>
  <div class="order-list-page">
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#3ea56e"
      size="128"
      is-full-screen
    />
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout v-else wrap justify-center>
      <v-flex xs12 sm12 md12 lg12 xl12 pa-5>
        
        <!-- Page Header -->
        <div class="page-header mb-5">
          <div class="header-left">
            <div class="header-icon-wrap">
              <v-icon color="white" size="22">mdi-package-variant-closed</v-icon>
            </div>
            <div>
              <h2 class="page-title">Orders</h2>
            </div>
          </div>
          <div class="header-actions" v-if="totalData">
            <div class="stat-chip mr-3">
              <v-icon size="14" color="#3ea56e" class="mr-1">mdi-cart-check</v-icon>
              <span>{{ totalData }} Total Orders</span>
            </div>
            
            <!-- Download PDF -->
            <v-btn
              depressed
              class="action-download-btn mr-2"
              height="38px"
              :href="
                baseURL +
                  '/admin/orders/list/pdf?sellerId=' +
                  sellerid +
                  '&orderStatus=' +
                  deliverystatus +
                  '&from=' +
                  from +
                  '&to=' +
                  to
              "
              target="_blank"
            >
              <v-icon left size="18" color="#ef4444">mdi-file-pdf-box</v-icon>
              <span>Download PDF</span>
            </v-btn>

            <!-- Download Excel -->
            <download-excel :data="user" :fields="json_fields" class="d-inline-block">
              <v-btn
                depressed
                class="action-download-btn"
                height="38px"
              >
                <v-icon left size="18" color="#22c55e">mdi-file-excel</v-icon>
                <span>Download Excel</span>
              </v-btn>
            </download-excel>
          </div>
        </div>

        <!-- Main Card -->
        <v-card class="modern-card" elevation="0">
          
          <!-- Filters Bar -->
          <div class="filters-bar py-4 px-5">
            <v-row dense>
              <v-col cols="12" sm="12" md="4" class="py-1">
                <v-autocomplete
                  v-model="sellerid"
                  :items="sellerList"
                  item-text="organization"
                  item-value="_id"
                  outlined
                  clearable
                  dense
                  label="Seller"
                  hide-details
                  prepend-inner-icon="mdi-store-outline"
                  class="modern-input"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4" md="3" class="py-1">
                <v-select
                  dense
                  :items="items"
                  v-model="deliverystatus"
                  label="Delivery Status"
                  outlined
                  clearable
                  hide-details
                  prepend-inner-icon="mdi-truck-delivery-outline"
                  class="modern-input"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4" md="2" class="py-1">
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="from"
                      label="From Date"
                      outlined
                      dense
                      hide-details
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      prepend-inner-icon="mdi-calendar"
                      class="modern-input"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="from"
                    no-title
                    color="#3ea56e"
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="4" md="3" class="py-1">
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="to"
                      label="To Date"
                      outlined
                      dense
                      hide-details
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      prepend-inner-icon="mdi-calendar"
                      class="modern-input"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="to"
                    no-title
                    color="#3ea56e"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </div>

          <v-divider></v-divider>

          <!-- Orders Container -->
          <div class="orders-container pa-5" v-if="user.length > 0">
            <div
              v-for="item in user"
              :key="item._id._id"
              class="order-card-wrapper mb-4"
            >
              <!-- Order Card Header -->
              <div class="order-card-header">
                <div class="order-card-header-left">
                  <span class="order-id-label">Order</span>
                  <span class="order-id-val">{{ item._id.orderID || (item._id._id ? '#' + item._id._id : 'N/A') }}</span>
                  <span class="order-date-divider">•</span>
                  <span class="order-date">{{ item.create_date }}</span>
                </div>
                <div class="order-card-header-right">
                  <span :class="['status-badge', getStatusClass(item._id.orderStatus)]">
                    {{ item._id.orderStatus }}
                  </span>
                </div>
              </div>

              <!-- Order Card Body -->
              <div class="order-card-body">
                <v-row align="center">
                  <!-- Collage / Photos -->
                  <v-col cols="12" sm="auto" class="d-flex justify-center justify-sm-start">
                    <div class="collage-container-wrap">
                      <Collage
                        :images="item.photos"
                        style="object-fit: contain !important"
                        :collageSizeMin="1"
                        :collageSizeMax="4"
                        :showNoImagesMsg="true"
                        noImagesMsg="No Images"
                        :showLoadingMsg="false"
                        loadingMsg="Loading..."
                        height="80px"
                        width="80px"
                      />
                    </div>
                  </v-col>

                  <!-- Details -->
                  <v-col cols="12" sm="9" md="6" class="text-left">
                    <div class="items-info-wrap">
                      <h3 class="items-title" :title="item._id.itemNames">
                        {{ item._id.itemNames }}
                      </h3>
                      
                      <v-row class="customer-info-grid mt-2" dense>
                        <v-col cols="6" sm="4">
                          <div class="info-block">
                            <span class="info-label">Customer Name</span>
                            <span class="info-value" v-if="item._id.uid">
                              {{ item._id.uid.firstname }} {{ item._id.uid.lastname }}
                            </span>
                          </div>
                        </v-col>
                        <v-col cols="6" sm="4">
                          <div class="info-block">
                            <span class="info-label">Phone</span>
                            <span class="info-value" v-if="item._id.uid">
                              {{ item._id.uid.phone }}
                            </span>
                          </div>
                        </v-col>
                        <v-col cols="6" sm="4">
                          <div class="info-block">
                            <span class="info-label">Payment Type</span>
                            <span class="info-value">
                              {{ item._id.paymentType }}
                            </span>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>

                  <!-- Amount -->
                  <v-col cols="12" sm="6" md="2" class="text-left mt-3 mt-md-0">
                    <div class="amount-wrap">
                      <span class="info-label d-block mb-1">Amount</span>
                      <span class="order-amount">Rs. {{ item._id.orderTotal }}</span>
                    </div>
                  </v-col>

                  <!-- Action View -->
                  <v-col cols="12" sm="6" md="2" class="text-left text-sm-right mt-3 mt-md-0">
                    <v-btn
                      depressed
                      class="action-view-btn"
                      @click="info(item._id._id)"
                    >
                      <v-icon left size="16">mdi-eye-outline</v-icon>
                      <span>View</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>

          <!-- Empty State -->
          <div class="empty-state" v-else>
            <v-icon size="56" color="#cbd5e1">mdi-package-variant</v-icon>
            <p class="empty-title">No orders found</p>
            <p class="empty-subtitle">Try adjusting your filters or date range</p>
          </div>

          <!-- Pagination -->
          <div class="pagination-wrap" v-if="pages > 1">
            <div class="pagination-info">
              <span>Page {{ currentPage }} of {{ pages }}</span>
            </div>
            <v-pagination
              :length="pages"
              :total-visible="7"
              v-model="currentPage"
              color="#3ea56e"
              class="modern-pagination"
            ></v-pagination>
          </div>

        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Collage from "vue-collage";
import axios from "axios";

export default {
  components: {
    Collage,
  },
  data() {
    return {
      appLoading: false,
      search: "",
      currentPage: 1,
      pages: 0,
      count: 20,
      totalData: 0,
      deliverystatus: null,
      menu1: false,
      menu2: false,
      date: new Date(),
      from: null,
      to: null,
      totalRows: 0,
      ServerError: false,
      headers: [
        { text: " Name", value: "firstname" },
        { text: "Products", value: "productname", tdClass: "tdwidth" },
        { text: "Amount", value: "amount" },
        { text: "Order Date", value: "Orderdate" },
        { text: "Delivery Status", value: "deliverystatus" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      user: [],
      data: [],
      category: [],
      items: [
        "Pending",
        "Order Confirmed",
        "Cancelled",
        "Cancelled By Seller",
        "Shipped",
        "Out For Delivery",
        "Delivered",
      ],
      productList: [],
      sellerList: [],
      sellerid: null,
      productid: null,
      json_fields: {
        FirstName: "_id.uid.firstname",
        LastName: "_id.uid.lastname",
        ProductName: "_id.itemNames",
        Phone: "_id.uid.phone",
        Email: "_id.uid.email",
        Amount: "_id.orderTotal",
        Payment: "_id.paymentType",
        Date: "_id.create_date",
      },
    };
  },
  mounted() {
    this.getData();
    this.getSellerList();
  },
  watch: {
    from() {
      this.getData();
    },
    to() {
      this.getData();
    },
    currentPage() {
      this.getData();
    },
    deliverystatus() {
      this.getData();
    },
    sellerid() {
      this.getData();
    },
  },
  methods: {
    getStatusClass(status) {
      if (!status) return 'status-pending';
      const s = status.toLowerCase();
      if (s.includes('pending')) return 'status-pending';
      if (s.includes('confirm')) return 'status-confirmed';
      if (s.includes('cancel')) return 'status-cancelled';
      if (s.includes('ship')) return 'status-shipped';
      if (s.includes('delivery') || s.includes('out for')) return 'status-out-for-delivery';
      if (s.includes('deliver')) return 'status-delivered';
      return 'status-pending';
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/admin/orders/list",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          count: this.count,
          page: this.currentPage,
          from: this.from,
          to: this.to,
          orderStatus: this.deliverystatus,
          sellerId: this.sellerid,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.user = response.data.data;
          this.pages = response.data.pages;
          this.totalData = response.data.count;
          var vm = this;
          this.user.forEach(function(itm) {
            itm.create_date = itm._id && itm._id.create_date ? vm.formatDate(itm._id.create_date) : '';
            itm.photos = [];
            itm.productname;

            if (itm.items.length > 0) {
              itm.items.forEach(function(itm2) {
                if (itm2.productId.photos.length > 0) {
                  itm.photos.push({
                    image: vm.mediaUURL + itm2.productId.photos[0],
                  });
                }
              });
            }
          });
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getSellerList() {
      axios({
        url: "/seller/activeall",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.sellerList = response.data.data;
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    info(pid) {
      this.$router.push("/orderDetails?id=" + pid);
    },
    edit(pid) {
      this.$router.push({ name: "editProduct", params: { purchaseid: pid } });
    },
    formatDate(item) {
      if (!item) return "";
      var dt = new Date(item);
      if (isNaN(dt.getTime())) return "";
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>

<style scoped>
/* Page Wrapper */
.order-list-page {
  background: #f5f6fa;
  min-height: 100vh;
  font-family: poppinsmedium, sans-serif;
}

/* Page Header */
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
}
.header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.header-icon-wrap {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #3ea56e, #2d8257);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(62, 165, 110, 0.35);
}
.page-title {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  line-height: 1.2;
}
.header-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.stat-chip {
  display: flex;
  align-items: center;
  background: #e8f5e9;
  border: 1px solid #c8e6c9;
  border-radius: 20px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  color: #2d8257;
  height: 38px;
}

/* Download Buttons */
.action-download-btn {
  background-color: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 10px !important;
  color: #334155 !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0px !important;
  transition: all 0.2s ease !important;
}
.action-download-btn:hover {
  background-color: #f8fafc !important;
  border-color: #cbd5e1 !important;
  transform: translateY(-1px);
}

/* Main Card */
.modern-card {
  border-radius: 16px !important;
  border: 1px solid #ebebeb !important;
  overflow: hidden;
  background: #ffffff;
}

/* Filters Bar */
.filters-bar {
  background: #ffffff;
}
.modern-input ::v-deep .v-input__slot {
  border-radius: 10px !important;
  font-size: 13px;
  border-color: #e2e8f0 !important;
}

/* Order Card Layout */
.order-card-wrapper {
  background: #ffffff;
  border: 1px solid #eaedf0;
  border-radius: 14px;
  overflow: hidden;
  transition: all 0.2s ease;
  text-align: left;
}
.order-card-wrapper:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);
  border-color: #3ea56e44;
}

.order-card-header {
  background: #f9fafb;
  border-bottom: 1px solid #eaedf0;
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.order-card-header-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.order-id-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #8a93a4;
  letter-spacing: 0.5px;
}
.order-id-val {
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
  margin-left: 4px;
  font-family: monospace;
}
.order-date-divider {
  color: #cbd5e1;
  margin: 0 10px;
}
.order-date {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}

.order-card-body {
  padding: 20px;
}
.collage-container-wrap {
  position: relative;
  width: 80px;
  height: 80px;
  border: 1.5px solid #3ea56e22;
  border-radius: 10px;
  padding: 6px;
  background: #f8fafc;
  display: inline-block;
  overflow: hidden;
  box-sizing: border-box;
}

.items-info-wrap {
  display: flex;
  flex-direction: column;
}
.items-title {
  font-size: 15px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 6px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.customer-info-grid {
  margin-top: 6px;
}
.info-block {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.info-label {
  font-size: 11px;
  color: #9ca3af;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.3px;
}
.info-value {
  font-size: 13px;
  color: #374151;
  font-weight: 600;
}

.amount-wrap {
  display: flex;
  flex-direction: column;
}
.order-amount {
  font-size: 17px;
  font-weight: 700;
  color: #10b981;
}

/* Action Button */
.action-view-btn {
  border-radius: 10px !important;
  background-color: #e8f5e9 !important;
  color: #2d8257 !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0px !important;
  padding: 8px 18px !important;
  height: 38px !important;
  border: 1px solid #c8e6c9 !important;
  transition: all 0.2s ease !important;
}
.action-view-btn:hover {
  background-color: #3ea56e !important;
  color: #ffffff !important;
  box-shadow: 0 4px 12px rgba(62, 165, 110, 0.25) !important;
  border-color: #3ea56e !important;
}

/* Status Badges */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  border-width: 1px;
  border-style: solid;
}
.status-pending {
  background-color: #fff3e0;
  color: #f76707;
  border-color: #ffa94d33;
}
.status-confirmed {
  background-color: #e7f5ff;
  color: #228be6;
  border-color: #748ffc33;
}
.status-cancelled {
  background-color: #ffe3e3;
  color: #fa5252;
  border-color: #ffa8a833;
}
.status-shipped {
  background-color: #f8f0fc;
  color: #be4bdb;
  border-color: #da77f233;
}
.status-out-for-delivery {
  background-color: #e6fcf5;
  color: #0ca678;
  border-color: #38d9a933;
}
.status-delivered {
  background-color: #e8f7ee;
  color: #3ea56e;
  border-color: #3ea56e33;
}

/* Empty State */
.empty-state {
  padding: 64px 20px;
  text-align: center;
}
.empty-title {
  font-size: 16px;
  font-weight: 600;
  color: #64748b;
  margin: 12px 0 4px;
}
.empty-subtitle {
  font-size: 13px;
  color: #94a3b8;
  margin: 0;
}

/* Pagination */
.pagination-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 14px 20px;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;
}
.pagination-info {
  font-size: 12px;
  color: #9e9e9e;
  font-weight: 500;
}
.modern-pagination ::v-deep .v-pagination__item {
  border-radius: 8px !important;
  font-size: 13px !important;
  min-width: 34px !important;
  height: 34px !important;
  box-shadow: none !important;
}
.modern-pagination ::v-deep .v-pagination__navigation {
  border-radius: 8px !important;
  box-shadow: none !important;
}

.tdwidth {
  width: 50% !important;
}
</style>
